var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 7.5,
    fill: "#28345A",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C16.3789 16.5 19.4919 18.482 21.7812 21.7959C24.0691 25.1077 25.5 29.7105 25.5 34.8184C25.5 35.7098 25.1617 36.3525 24.5508 36.8477C23.9159 37.3622 22.9647 37.7326 21.7305 37.9873C19.2588 38.4974 15.8869 38.5 12.2773 38.5C8.66056 38.5 5.84608 38.4962 3.83887 37.9922C2.84739 37.7432 2.09722 37.3814 1.55664 36.8721C1.02994 36.3757 0.66797 35.7058 0.5 34.7686C0.509236 29.6805 1.93831 25.097 4.21875 21.7959C6.50805 18.482 9.6211 16.5 13 16.5Z",
    fill: "#28345A",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 8,
    r: 7.5,
    fill: "#28345A",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16.5C48.3789 16.5 51.4919 18.482 53.7812 21.7959C56.0691 25.1077 57.5 29.7105 57.5 34.8184C57.5 35.7098 57.1617 36.3525 56.5508 36.8477C55.9159 37.3622 54.9647 37.7326 53.7305 37.9873C51.2588 38.4974 47.8869 38.5 44.2773 38.5C40.6606 38.5 37.8461 38.4962 35.8389 37.9922C34.8474 37.7432 34.0972 37.3814 33.5566 36.8721C33.0299 36.3757 32.668 35.7058 32.5 34.7686C32.5092 29.6805 33.9383 25.097 36.2188 21.7959C38.5081 18.482 41.6211 16.5 45 16.5Z",
    fill: "#28345A",
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 13,
    r: 7.5,
    fill: "#28345A",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.5C32.3789 21.5 35.4919 23.482 37.7812 26.7959C40.0691 30.1077 41.5 34.7105 41.5 39.8184C41.5 40.7098 41.1617 41.3525 40.5508 41.8477C39.9159 42.3622 38.9647 42.7326 37.7305 42.9873C35.2588 43.4974 31.8869 43.5 28.2773 43.5C24.6606 43.5 21.8461 43.4962 19.8389 42.9922C18.8474 42.7432 18.0972 42.3814 17.5566 41.8721C17.0299 41.3757 16.668 40.7058 16.5 39.7686C16.5092 34.6805 17.9383 30.097 20.2188 26.7959C22.5081 23.482 25.6211 21.5 29 21.5Z",
    fill: "#28345A",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.47c8746d2bb3559aa19c9c8406495435.svg";
export { ForwardRef as ReactComponent };